import { createSvgComponent } from "../../icon/createSvgComponent";
import Event from "@core/icon/assets/event.svg";
export default createSvgComponent(Event);